export { default } from './QuoteCarouselBlock';
export * from './QuoteCarouselBlock';
